import { type ViewPageContentTabType } from 'app/main/components/page-layouts/view/ViewPage';

import InvoicesTableTab from './tabs/InvoicesTableTab';
import InvoicesDeadlinesTab from './tabs/InvoicesDeadlinesTab';
import InvoicesDeadlinesCalendarTab from './tabs/InvoicesDeadlinesCalendarTab';

const tabs: ViewPageContentTabType[] = [
	{
		id: 'list',
		title: 'TAB_LIST',
		hidden: ({ authorizer }) => authorizer.cannot('view', 'invoices'),
		content: props => <InvoicesTableTab {...props} />
	},
	{
		id: 'deadlines',
		title: 'TAB_INVOICES_DEADLINES',
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('invoices_deadlines') || authorizer.cannot('view', 'invoices_deadlines'),
		content: () => <InvoicesDeadlinesTab />
	},
	{
		id: 'deadlines-calendar',
		title: 'TAB_INVOICES_DEADLINES_CALENDAR',
		hidden: ({ isModuleDisabled, authorizer }) =>
			isModuleDisabled('invoices_deadlines') || authorizer.cannot('view', 'invoices_deadlines'),
		content: () => <InvoicesDeadlinesCalendarTab />
	}
];

export default tabs;
